export default __webpack_public_path__ + "static/media/actify_logo.3c1be232.svg";